import React, {memo} from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import * as colors from '@constants/colors';

import EntityTypeIcon from '@icons/entity-type-icon';
import GroupTypeIcon from '@icons/group-type-icon';

import { Icon } from '@mui';

import styles from './icon.scss';

const MenuIcon = ({icon, type, active}) => {
  if (icon === '[entity]') {
    const color = active ? colors.secondaryColor : '616161';
    return <EntityTypeIcon type={type} size="1.5rem" color={color} />;
  }
  if (icon === '[group]') {
    const color = active ? colors.secondaryColor : '616161';
    return <GroupTypeIcon type={type} size="1.5rem" color={color} />;
  }
  return (
    // aria-hidden - decorative: this menu item's own visible label already conveys its name;
    // without this, role="img" (MUI Icon's default) exposes the raw ligature text (e.g.
    // "person", "corporate_fare") as if it were real alt text, read right before the label.
    <Icon
      classes={{
        root: classNames(
          'material-icons',
          styles.icon,
          {[styles.active]: active}
        )
      }}
      aria-hidden="true"
      translate="no">
      {icon}
    </Icon>
  );
};

MenuIcon.propTypes = {
  active: PropTypes.bool,
  icon: PropTypes.string,
  type: PropTypes.string
};

export default memo(MenuIcon);
